"use client";

import { useCart } from "@/components/cart/CartProvider";

export function CartButton() {
  const { cart, open } = useCart();
  const count = cart?.totalQuantity ?? 0;

  return (
    <button type="button" onClick={open} className="py-2 nav-link">
      Cart
      <span className="ml-1 tabular-nums" aria-label={`${count} ${count === 1 ? "item" : "items"}`}>
        ({count})
      </span>
    </button>
  );
}
